import { render, staticRenderFns } from "./AscNavigationButton.vue?vue&type=template&id=54c13024&"
import script from "./AscNavigationButton.vue?vue&type=script&lang=js&"
export * from "./AscNavigationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports